import {
  HttpContextToken,
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpStatusCode
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import {
  BehaviorSubject,
  catchError,
  filter,
  Observable,
  switchMap,
  take
} from "rxjs";
import { AuthService } from "../../services/auth/auth.service";

export const SKIP_TOKEN = new HttpContextToken(() => false);

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private isRefreshing = false;
  private refreshDoneSubject = new BehaviorSubject<boolean>(false);

  constructor(private readonly authService: AuthService) {}

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    // Add cookies to request
    if (!req.context.get(SKIP_TOKEN)) {
      req = req.clone({ withCredentials: true });
    }

    return next.handle(req).pipe(
      catchError((error) => {
        if (error instanceof HttpErrorResponse) {
          if (error.status === HttpStatusCode.Unauthorized) {
            return this.handleRefreshToken(req, next);
          }
        }

        throw error;
      })
    );
  }

  private handleRefreshToken(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (this.isRefreshing) {
      return this.refreshDoneSubject.pipe(
        filter((value) => value === true),
        take(1),
        switchMap(() => {
          return next.handle(req);
        })
      );
    } else {
      this.isRefreshing = true;
      this.refreshDoneSubject.next(false);

      // Refresh token
      const onBehalfOfId = this.authService.onBeHalfOfUserId;
      return this.authService.login({ onBehalfOf: onBehalfOfId }).pipe(
        catchError((error) => {
          this.isRefreshing = false;
          this.authService.logout().subscribe();
          throw error;
        }),
        switchMap(() => {
          this.isRefreshing = false;
          this.refreshDoneSubject.next(true);
          return next.handle(req);
        })
      );
    }
  }
}
